// we could also pull down sample files and calculate these
// this is simpler but the other way ensures consistency between validation and our examples
export const REQUIRED_SIMULATION_UPLOAD_HEADERS = [
  'currency_code',
  'shipment_id',
  'shipped_date_time',
  'origin_state_region',
  'origin_postal_code',
  'origin_country_code',
  'destination_state_region',
  'destination_postal_code',
  'destination_country_code',
  'package_material',
  'package_length',
  'package_width',
  'package_height',
  'package_linear_unit',
  'package_weight',
  'package_weight_unit',
];

export const ALLOWED_SIMULATION_UPLOAD_HEADERS = [
  ...REQUIRED_SIMULATION_UPLOAD_HEADERS,
  'fulfillment_context_id',
  'tenant_id',
  'tenant_name',
  'reference_identifier',
  'limited_quantity',
  'lithium_ion',
  'hazmat',
  'ormd',
  'desired_delivery_date',
  'buisness_days_of_transit',
  'ship_option',
  'destination_is_po_box',
  'destination_address_type',
  'label_cost',
  'business_days_of_transit',
  'carrier_service_method_id',
  'delivered_at_date',
  'time_in_transit_days',
  'time_in_transit_data_type',
  'ignore_upgrade_spend_limits',
  'saturday_delivery_requested',
  'OPTIONAL_FIELDS_FOLLOW',
];
